import {
  SET_CURRENT_USER,
  SET_LOGGEDIN_USER,
  SET_REDIRECT_PATH
} from "../actions/types";
import isEmpty from "lodash/isEmpty";

const initialState = {
  isAuthenticated: false,
  user: {},
  profile: {},
  redirect: null,
  redirectPayload: {}
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: !isEmpty(action.user),
        user: action.user
      };
    case SET_LOGGEDIN_USER:
      console.log(action);
      return {
        ...state,
        profile: action.profile,
        user: Object.assign({}, { user: action.profile })
      };
    case SET_REDIRECT_PATH:
      return {
        ...state,
        redirect: action.path,
        redirectPayload: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/reducers/auth.js